import { render, staticRenderFns } from "./OverviewContent.vue?vue&type=template&id=37d30856&scoped=true"
import script from "./OverviewContent.vue?vue&type=script&lang=js"
export * from "./OverviewContent.vue?vue&type=script&lang=js"
import style0 from "./OverviewContent.vue?vue&type=style&index=0&id=37d30856&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d30856",
  null
  
)

export default component.exports